import React from "react";
import { FullScreenDialog } from "../core/FullScreenDialog";
import { useMyEntitlements } from "@seabrookstudios/pitch2table";
import Typography from "@mui/material/Typography";
import { UploadAsset } from "./Upload";

/**
 * @param {object} props
 * @param {import("@seabrookstudios/types").GameId} props.gameId
 */
export default function Add({ gameId }) {
  const { data: entitlements } = useMyEntitlements();

  const hasLargeFileUploads = entitlements && entitlements.hasLargeFileUploads;

  return (
    <FullScreenDialog title="Add File" canSave={true}>
      <UploadAsset gameId={gameId} />
      <Typography variant="body2" textAlign="right" color="text.secondary">
        Maximum file size: {hasLargeFileUploads ? "500MB" : "5MB"}
      </Typography>
    </FullScreenDialog>
  );
}
